"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const TitledRow = (_a) => {
    var { title, lineOne, lineTwo } = _a, props = __rest(_a, ["title", "lineOne", "lineTwo"]);
    return (react_1.default.createElement(styles_1.Row, Object.assign({}, props),
        react_1.default.createElement(styles_1.SubHeading, { "data-testid": "heading" }, title),
        lineOne && react_1.default.createElement(styles_1.RowContent, { "data-testid": "row__1" }, lineOne),
        lineTwo && react_1.default.createElement(styles_1.RowContent, { "data-testid": "row__2" }, lineTwo)));
};
exports.default = TitledRow;
//# sourceMappingURL=TitledRow.js.map